import { render, staticRenderFns } from "./sec-noticias.vue?vue&type=template&id=a4a1dfbc&scoped=true&"
import script from "./sec-noticias.vue?vue&type=script&lang=js&"
export * from "./sec-noticias.vue?vue&type=script&lang=js&"
import style0 from "./sec-noticias.vue?vue&type=style&index=0&id=a4a1dfbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a1dfbc",
  null
  
)

export default component.exports